import { createFeature, createReducer, on } from '@ngrx/store';

import * as actions from './maf-get.actions';
import { SharedPageTypeEnum } from 'src/app/shared/navigation/page-type.enum';
import { ContainerMafGetResponseI } from 'src/app/api/container-maf-get/container-maf-get-result.int';
import { ContainerMafGetQueryI } from 'src/app/api/container-maf-get/container-maf-get-query.int';

interface StateObjectI {
  data: ContainerMafGetResponseI;
  errorMessage: string;
  loaded: boolean;
  loading: boolean;
  query: ContainerMafGetQueryI;
}

export interface State {
  lastUsedPageType: SharedPageTypeEnum;
  [SharedPageTypeEnum.infCnt]: StateObjectI;
  [SharedPageTypeEnum.quaDischarge]: StateObjectI;

}

export const initialState: State = {
  lastUsedPageType: null,
  [SharedPageTypeEnum.infCnt]: {
    data: null,
    errorMessage: null,
    loaded: null,
    loading: null,
    query: null,
  },
  [SharedPageTypeEnum.quaDischarge]: {
    data: null,
    errorMessage: null,
    loaded: null,
    loading: null,
    query: null,
  },
};

export default createFeature({
  name: 'mafGet',
  reducer: createReducer(
  initialState,
  on(actions.error, (state: State, { pageType, messageText }): State => ({
    ...state,
    [pageType]: {
      ...state[pageType],
      loading: false,
      errorMessage: messageText
    }
  })),
  on(actions.load, (state: State, { pageType, query }): State => ({
    ...state,
    lastUsedPageType: pageType,
    [pageType]: {
      ...state[pageType],
      loading: true,
      query,
    }
  })),
  on(actions.received, (state: State, { pageType, data }): State => ({
    ...state,
    [pageType]: {
      ...state[pageType],
      loaded: true,
      loading: false,
      data,
    }
  })),
  on(actions.reset, (_state: State, { }): State => ({
    ...initialState,
  })),
  )}
);